import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule }            from '../shared/shared.module';
import { StripeCheckoutComponent } from './stripe.checkout.component';
import { StripePaymentComponent }  from './stripe.payment.component';
import { StripeService } from './stripe.service';

@NgModule({
  declarations: [
    StripeCheckoutComponent,
    StripePaymentComponent,
  ],
  entryComponents: [
    StripeCheckoutComponent,
    StripePaymentComponent
  ],
  exports: [
    StripeCheckoutComponent,
    StripePaymentComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    StripeService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class StripeModule {}